/**
 * ai-transport.ts — standard transport for AI-chatten: den ekte backend (lib/api.ts)
 *
 * AiChatDrawer bruker denne når ingen `transport` er gitt (dashbordet). Mockupen i Shell2 sender inn en lokal erstatning (ui-shell2/ai-mock.ts).
 */

import { fetchAiConversations, fetchAiMessages, streamAiChat } from '@/lib/api';
import type { AiTransport } from '@/types/ai';

export const realAiTransport: AiTransport = {
  stream: streamAiChat,
  listConversations: fetchAiConversations,
  listMessages: fetchAiMessages,
};
